import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Route, RouterModule } from '@angular/router'

import { PostPageComponent } from './components/post-page.component'

import { ClubsDomainModule } from '@alliance/clubs/domain'
import { ClubsRubricsModule } from '@alliance/clubs/rubrics'
import { ClubsTagsModule } from '@alliance/clubs/tags'
import { ClubsUiDateModule } from '@alliance/clubs/ui/date'
import { ClubsUiViewsModule } from '@alliance/clubs/ui/views'
import { ClubsUtilsModule } from '@alliance/clubs/utils'
import { ClubsPostAuthorModule } from '@alliance/clubs/post-author'
import { ClubsRelatedPostsModule } from '@alliance/clubs/related-posts'
import { ClubsUiBreadcrumbsModule } from '@alliance/clubs/ui/breadcrumbs'
import { ClubsUiBackButtonModule } from '@alliance/clubs/ui/back-button'

import { SharedPipesBypassSanitizerModule } from '@alliance/shared/pipes/bypass-sanitizer'
import { SharedTranslationModule } from '@alliance/shared/translation'

import { SantaSkeletonLoaderModule } from '@alliance/santa/skeleton-loader'

const ClubsModules = [
  ClubsDomainModule,
  ClubsRubricsModule,
  ClubsTagsModule,
  ClubsUiDateModule,
  ClubsUiViewsModule,
  ClubsUtilsModule,
  ClubsPostAuthorModule,
  ClubsRelatedPostsModule,
  ClubsUiBreadcrumbsModule,
  ClubsUiBackButtonModule
]

const SharedModules = [SharedPipesBypassSanitizerModule, SharedTranslationModule]

const SantaModules = [SantaSkeletonLoaderModule]

export const routes: Route[] = [
  {
    path: '',
    component: PostPageComponent
  }
]

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes), ...ClubsModules, ...SharedModules, ...SantaModules],
  declarations: [PostPageComponent]
})
export class ClubsPostPageModule {}
